import { customerPortalHost } from '~/services/common';

export type CustomerPortalTenant = App.Tenant | { value: string } | string;

function normaliseTenant(tenant: CustomerPortalTenant): App.Tenant {
  if (typeof tenant === 'string') {
    return { value: tenant } as App.Tenant;
  }

  return tenant as App.Tenant;
}

export default function buildCustomerPortalUrl(tenant: CustomerPortalTenant, path: string): string | null {
  const host = customerPortalHost(normaliseTenant(tenant));

  if (!host) {
    return null;
  }

  return `${host}${path}`;
}
